<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" [routerLink]="getEditRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.machinesafety.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-row" *ngIf="machineSafety.GuardsTested !== null && machineSafety.GuardsTested >= 0">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.machinesafety.guards-tested' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ machineSafety.GuardsTested | machinesafetyyesno }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row" *ngIf="machineSafety.GuardsSecured !== null && machineSafety.GuardsSecured >= 0">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.machinesafety.guards-secured' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ machineSafety.GuardsSecured | machinesafetyyesno }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row" *ngIf="machineSafety.CustomerInformedName">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.machinesafety.customer-informed-name' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ machineSafety.CustomerInformedName }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row" *ngIf="machineSafety.PartsNeeded !== null && machineSafety.PartsNeeded >= 0">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.machinesafety.parts-needed' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ machineSafety.PartsNeeded | machinesafetyyesno }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row" *ngIf="machineSafety.Comment">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.machinesafety.comment' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ machineSafety.Comment }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
